import {
  FETCH_PRACTITIONAR_REQUEST,
  FETCH_PRACTITIONAR_SUCCESS,
  FETCH_PRACTITIONAR_FAILURE,
} from "./practitionerTypes";
import api from "../../utils/Api";

export const fetchpractitionerRequest = () => {
  return {
    type: FETCH_PRACTITIONAR_REQUEST,
  };
};

export const fetchpractitionerSuccess = (practitioner) => {
  return {
    type: FETCH_PRACTITIONAR_SUCCESS,
    payload: practitioner,
  };
};

export const fetchpractitionerFailure = (error) => {
  return {
    type: FETCH_PRACTITIONAR_FAILURE,
    payload: error,
  };
};

export const fetchpractitioner = (practitioner_name, isBillingPractitioner) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  let url = "relatedparty/practitioner/autocomplete?practitioner_name="+practitioner_name;
  if(isBillingPractitioner){
    url += "&isBillingPractitioner=" + isBillingPractitioner ;
  }
  return async (dispatch) => {
    dispatch(fetchpractitionerRequest);
    try {
      const response = await api.get(url ,
        {
          headers: headers,
        }
      );

      const practitioner = response.data.data;
      //console.log("******* practitioner autocomplete - ", practitioner);
      dispatch(fetchpractitionerSuccess(practitioner));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchpractitionerFailure(errorMsg));
    }
  };
};
